import { Action, ActionType, PageType, State } from "../types";

export const handleConfirmMmp = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.CONFIRM_MMP_POI_REQUESTED: {
      return {
        ...state,
        page: PageType.PROOF_OF_INCOME,
        bankConnectUrl: action.bankConnectUrl,
        latitudePoiUrl: action.latitudePoiUrl,
        cancelUrl: action.cancelUrl,
      };
    }

    case ActionType.CONFIRM_MMP_SUCCEEDED: {
      return {
        ...state,
        page: PageType.APPROVED,
        minimumMonthlyPayment: action.minimumMonthlyPayment,
        newCreditLimit: String(action.approvedCreditLimit),
      };
    }

    case ActionType.ACKNOWLEDGE_APPLICATION_FAILED: {
      return {
        ...state,
        page: PageType.ERROR,
      };
    }

    case ActionType.FINAL_CANCEL_FAILED: {
      return {
        ...state,
        page: PageType.ERROR,
      };
    }

    case ActionType.FINAL_CANCEL: {
      return {
        ...state,
        page: PageType.FINAL_CANCEL,
      };
    }

    default: {
      return state;
    }
  }
};
